(() => {
	angular.module('main').controller('SignUpController', SignUpController);

	SignUpController.$inject = [
		'$scope',
		'$rootScope',
		'$location',
		'$http',
		'$filter',
		'$window',
		'accountService',
		'messageService',
		'validationService',
		'settingsService',
		'$timeout'
	];

	function SignUpController(
		$scope,
		$rootScope,
		$location,
		$http,
		$filter,
		$window,
		accountService,
		messageService,
		validationService,
		settingsService,
		$timeout
	) {
		$scope.$on('$viewContentLoaded', () => {
			getTimezoneList();
			getCurrencyList();
			// document.cookie = "reCAPTCHA_token=true";
			$scope.navbarSignIn = false;
			$scope.navbarSignUp = true;
			$scope.isRecaptchaInitialized = false;
			$scope.button_disable = false;
			$scope.userToSignup = {};
			$scope.isShowTootlip = false;
			$scope.isTest = document.cookie.includes('reCAPTCHA_token');

			if (!$rootScope.password_token) {
				const invitationCompany = accountService.getInvitationCompany();

				if (invitationCompany instanceof Rx.Observable) {
					invitationCompany.subscribe(
						data => successGetInvitationCompany(data),
						error => messageService.showDefaultErrorMessage(error)
					);
				}

				const restPathUrl = '/public/rest/user/signup/';
				const confirmPathPart = 'register/';
				let url = $location.path();
				const index = url.indexOf(confirmPathPart);
				let token = null;

				if (index !== -1 && index + confirmPathPart.length < url.length) {
					token = url.substring(confirmPathPart.length + index, url.length);
				}

				if (token) {
					url = restPathUrl + token;
					$http
						.get(url)
						.then(result => successGetInvitationCompany(result.data))
						.catch(messageService.showDefaultErrorMessage);
				}
			}
		});

		function successGetInvitationCompany(data) {
			if (data) {
				$scope.invite = true;
				$scope.userToSignup.companyName = data.name;
			}
		}

		function getTimezoneList() {
			settingsService.getTimezoneList().subscribe(data => {
				if (data) {
					$scope.timezoneList = $filter('timezoneFilter')(data);
				}
			});
		}

		function getCurrencyList() {
			settingsService.getCurrencyList().subscribe(data => {
				if (data) {
					$scope.currencyList = data;
				}
			});
		}

		function signUpSuccessCallback(data) {
			// Google Tag Manager event
			dataLayer.push({
				pageCategory: 'signup',
				event: 'signup'
			});

			messageService.showToaster('s_0', 'login');
			$rootScope.firstName = $scope.signUpData.firstName;

			const { textHTML, titleHTML } = data.data.signUpPromotionInfo;

			$rootScope.textHtml = textHTML;
			$rootScope.titleHtml = titleHTML;

			$location.path('/signup/thankyou');

			$scope.button_disable = false;
		}

		function signUpErrorCallback({ error }) {
			$scope.isSubmitSpinningWheelActive = false;
			const { errorMessage = '', errorTitle, errorCode } = error;

			const EMAIL_BUSY = 'User with such email already registered';
			const COMPANY_NAME_BUSY = 'Company name already exists';

			$scope.button_disable = false;
			$rootScope.authenticated = false;
			$rootScope.error = true;

			if (errorCode) {
				messageService.showErrorFromBackend(errorTitle, errorMessage);
				return;
			}

			switch (errorMessage) {
				case EMAIL_BUSY:
					messageService.showToaster('e_2', 'login');
					break;
				case COMPANY_NAME_BUSY:
					messageService.showToaster('e_3', 'login');
					break;
				default:
					getDefaultErrorMessage(errorMessage);
			}

			function getDefaultErrorMessage(message) {
				const POSTMARKUP_ERROR_START = '{ErrorCode:406,Message:';
				const POSTMARKUP_ERROR_END = ' }';

				if (message.includes(POSTMARKUP_ERROR_START)) {
					const postmarkupMessage = message
						.replace(POSTMARKUP_ERROR_START, '')
						.replace(POSTMARKUP_ERROR_END, '');
					toastr.error(postmarkupMessage);
				} else {
					$rootScope.error_message = 'Failed request to server';
					toastr.error('Failed request to server', 'Error');
				}
			}
		}

		function successCompanyRegister() {
			$scope.button_disable = false;
			$scope.isSubmitSpinningWheelActive = false;
			messageService.showToaster('s_1', 'login');
			$location.path('/login');
		}

		$scope.validateForm = function(userToSignup) {
			const {
				companyName,
				firstName,
				email,
				password,
				passwordConfirm,
				currency,
				timezone,
				promoSubscription,
				termsOfUseAccepted
			} = userToSignup;
			userToSignup.promoSubscription = true;
			delete $rootScope.error;
			if (!$scope.isRecaptchaInitialized && !$scope.isTest) {
				$scope.id = grecaptcha.render('recaptcha', {
					sitekey: '6Le_szsUAAAAALL60TzetiuWGDYT_jDUj1rdFwNR',
					callback: 'signUp',
					size: 'invisible'
				});
				$scope.isRecaptchaInitialized = true;
			}

			if (!userToSignup.termsOfUseAccepted) {
				$scope.isShowTootlip = true;
				$timeout(() => {
					$scope.isShowTootlip = false;
				}, 3000);
			} else {
				$scope.isShowTootlip = false;
			}

			const MIN_PASSWORD_LENGTH = 6;

			if (password.length < MIN_PASSWORD_LENGTH) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('w_0', 'login');
			}

			if (passwordConfirm !== password) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('e_6', 'login');
			}

			if (password.trim().length === 0) {
				$scope.isSubmitSpinningWheelActive = false;
				$scope.button_disable = false;
				return messageService.showToaster('e_3', 'general', 'password');
			}

			if (!userToSignup.termsOfUseAccepted) {
				return false;
			}

			let restPathUrl, confirmPathPart, index, token;

			restPathUrl = '/public/rest/user/signup/';
			confirmPathPart = 'register/';

			$scope.url = $location.path();
			index = $scope.url.indexOf(confirmPathPart);
			token = null;

			if (index !== -1 && index + confirmPathPart.length < $scope.url.length) {
				token = $scope.url.substring(
					confirmPathPart.length + index,
					$scope.url.length
				);
				$scope.url = restPathUrl + token;
			} else {
				$scope.url = null;
			}

			$scope.button_disable = true;
			$scope.isSubmitSpinningWheelActive = true;

			$scope.signUpData = {
				firstName,
				email,
				password,
				passwordConfirm,
				promoSubscription,
				termsOfUseAccepted
			};
			$scope.signUpData.promoSubscription = true;
			if ($scope.url) {
				$scope.signUpData.inviteToken = token;

				if (validationService.isStringEmpty($scope.signUpData.firstName)) {
					$scope.button_disable = false;
					$scope.isSubmitSpinningWheelActive = false;
					return messageService.showToaster('e_4', 'login');
				}
				if (!$scope.isTest) {
					grecaptcha.execute($scope.id);
				} else {
					$scope.signUp(null);
				}

				$scope.button_disable = false;
			} else {
				$scope.signUpData.companyName = companyName;
				$scope.signUpData.timezone = timezone.key;
				$scope.signUpData.currency = currency.currencyCode;

				if (
					validationService.isStringEmpty($scope.signUpData.firstName) ||
					validationService.isStringEmpty($scope.signUpData.companyName)
				) {
					$scope.button_disable = false;
					$scope.isSubmitSpinningWheelActive = false;
					return messageService.showToaster('e_4', 'login');
				}

				if (!$scope.isTest) {
					grecaptcha.execute($scope.id);
				} else {
					$scope.signUp(null);
				}
				$scope.button_disable = false;
			}
		};

		$scope.signUp = function(token) {
			$scope.button_disable = true;
			$scope.isSubmitSpinningWheelActive = true;

			$scope.signUpData.reCaptchaToken = token;

			if ($scope.url) {
				accountService.companyRegister(
					$scope.signUpData,
					successCompanyRegister,
					signUpErrorCallback
				);
			} else {
				accountService.signUp(
					$scope.signUpData,
					signUpSuccessCallback,
					signUpErrorCallback
				);
			}

			grecaptcha.reset($scope.id);
		};

		$window.signUp = $scope.signUp;
	}
})();



// WEBPACK FOOTER //
// ./web/js/controllers/login/signUpController.js